export default "__VITE_ASSET__74babe08__"